import script from "./PDFDownload.vue?vue&type=script&lang=ts&setup=true"
export * from "./PDFDownload.vue?vue&type=script&lang=ts&setup=true"

import "./PDFDownload.vue?vue&type=style&index=0&id=1eeefde7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eeefde7"]])

export default __exports__